module.exports = __webpack_public_path__ + "static/media/chalkboard.355a8601.png";